import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Field } from "../components/Shared";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";
import { ROLES } from "../lib/labels";
import { AuthShell } from "./Login";

export default function AcceptInvite() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [form, setForm] = useState({ name: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get(`/auth/invitation/${token}`)
      .then((r) => { setInvite(r.data); setForm((f) => ({ ...f, name: r.data.name })); })
      .catch((e) => setError(formatApiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/accept-invite", { token, ...form });
      setUser(data.user);
      navigate("/app");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={invite ? `Rejoindre ${invite.company_name}` : "Invitation"}
      subtitle={invite ? `Vous êtes invité en tant que ${ROLES[invite.role]}. Créez votre accès personnel.` : "Vérification de l'invitation…"}
    >
      {!invite && error && <p className="text-sm text-red-600" data-testid="invite-error">{error}</p>}
      {invite && (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <Field label="E-mail"><Input data-testid="invite-email-input" value={invite.email} disabled /></Field>
          <Field label="Votre nom"><Input data-testid="invite-name-input" required minLength={2} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Field>
          <Field label="Mot de passe (8 caractères min.)"><Input data-testid="invite-password-input" type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></Field>
          {error && <p className="text-sm text-red-600" data-testid="invite-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-[#0b2c6b] hover:bg-[#1559d6]" data-testid="accept-invite-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Créer mon accès
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
